import { forwardRef, useState } from "react";
import { Play } from "lucide-react";
import { TRAILER_YOUTUBE_ID } from "@/lib/constants";
import { Reveal } from "./Reveal";

export const Trailer = forwardRef((props, ref) => {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="trailer" ref={ref} className="px-5 sm:px-8 lg:px-12 py-20 sm:py-28" data-testid="trailer">
      <Reveal className="mb-10 text-center">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-green-deep">Il trailer ufficiale</p>
        <h2 className="mx-auto max-w-3xl font-serif tracking-tightest text-4xl sm:text-6xl leading-[1.0] text-navy text-balance">
          Da qui in poi, non parliamo più noi.
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="relative mx-auto aspect-video max-w-5xl overflow-hidden rounded-[2rem] glass-strong p-2.5">
          <div className="h-full w-full overflow-hidden rounded-[1.6rem] bg-navy/5">
            {playing ? (
              <iframe
                className="h-full w-full"
                src={`https://www.youtube.com/embed/${TRAILER_YOUTUBE_ID}?autoplay=1&rel=0`}
                title="Trailer ufficiale Cosplay Singers"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid="trailer-iframe"
              />
            ) : (
              <button data-testid="trailer-play-btn" aria-label="Riproduci il trailer ufficiale" onClick={() => setPlaying(true)} className="group relative h-full w-full">
                <img src={`https://img.youtube.com/vi/${TRAILER_YOUTUBE_ID}/maxresdefault.jpg`} alt="Anteprima del trailer ufficiale delle Cosplay Singers" className="h-full w-full object-cover" />
                <span className="absolute inset-0 flex items-center justify-center bg-navy/15">
                  <span className="flex h-20 w-20 items-center justify-center rounded-full bg-white/85 text-lavender-deep backdrop-blur-md transition-transform duration-300 group-hover:scale-110 soft-shadow">
                    <Play size={28} className="fill-current ml-1" />
                  </span>
                </span>
              </button>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
});

Trailer.displayName = "Trailer";
